// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"195e1ae7","626":"fd53e519"}[chunkId] + ".chunk.js";
};